import { useEffect } from "react";
function useDebouncedEffect(fn, delay, deps = []) {
  useEffect(() => {
    const id = setTimeout(fn, delay);
    return () => clearTimeout(id);
  }, [delay, ...deps]);
}
export {
  useDebouncedEffect as default
};
//# sourceMappingURL=use-debounced-effect.js.map
